import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../auth/authentication.service';
import { SecuredSessionEncodedData } from '../../models/auth/secured-session-encoded-data.model';
import { CFDocumentSecuredSessionAccessToken } from '../../models/cf-document/cf-document-secured-session-access-token.model';
import { base64toJson } from '../../util/utils';
import { CFSignatureStoreService } from '../signatures/cf-signature-store.service';
import { CFDocumentStoreService } from './cf-document-store.service';

@Injectable({ providedIn: 'root' })
export class CFDocumentSecuredSessionResolver implements Resolve<SecuredSessionEncodedData> {
    constructor(
        private authService: AuthenticationService,
        private documentStoreService: CFDocumentStoreService,
        private signatureStoreService: CFSignatureStoreService
    ) {}

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<SecuredSessionEncodedData> | Promise<SecuredSessionEncodedData> | SecuredSessionEncodedData {
        const accessTokenString = decodeURIComponent(route.queryParamMap.get('accessToken'));
        const securedSessionAccessToken = base64toJson(accessTokenString) as CFDocumentSecuredSessionAccessToken;

        this.documentStoreService.resetFilters();
        this.signatureStoreService.resetFilters();

        this.documentStoreService.cloudFlowDocumentId = securedSessionAccessToken.resourceId;
        this.signatureStoreService.selectedSignerId = securedSessionAccessToken.participantId;
        this.signatureStoreService.selectedSectionId = securedSessionAccessToken.sectionId;

        return new Promise((resolve, reject) => {
            this.authService
                .getSessionEncodedData(securedSessionAccessToken.securedSessionId)
                .subscribe((encodedSessionData: SecuredSessionEncodedData) => {
                    resolve(encodedSessionData);
                });
        });
    }
}
